import MobileFilterSheet from "../../ui/MobileFilterSheet";

function DetailRow({ label, value }) {
  if (value === undefined || value === null || value === "") return null;
  return (
    <div className="flex border-b border-primary/20 py-2 text-sm">
      <span className="w-28 shrink-0 text-laranjinha/60">{label}</span>
      <span className="flex-1 font-medium text-laranjinha">{value}</span>
    </div>
  );
}

export function MobileTagErrorSheet({ open, onClose, data }) {
  return (
    <MobileFilterSheet open={open} onClose={onClose} title={data?.serial ?? "Erro na etiqueta"}>
      {data?.fields?.length ? (
        <ul className="space-y-3">
          {data.fields.map((field, index) => (
            <li key={index} className="rounded-lg border border-red-700/50 bg-red-950/30 px-3 py-2 text-sm">
              <p>
                <span className="text-laranjinha/60">Campo: </span>
                <span className="font-medium text-laranjinha">{field?.key}</span>
              </p>
              <p>
                <span className="text-laranjinha/60">Valor: </span>
                <span className="font-medium text-laranjinha">{field?.value}</span>
              </p>
              <p>
                <span className="text-laranjinha/60">Limite (px): </span>
                <span className="font-medium text-laranjinha">{field?.limite}</span>
              </p>
              <p>
                <span className="text-laranjinha/60">Excedido: </span>
                <span className="font-medium text-laranjinha">
                  {field?.excedido != null ? parseFloat(field.excedido).toFixed(2) : "—"}
                </span>
              </p>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-laranjinha/70">Nenhum detalhe de erro disponível.</p>
      )}
    </MobileFilterSheet>
  );
}

export function MobileTagInfosSheet({ open, onClose, model }) {
  return (
    <MobileFilterSheet open={open} onClose={onClose} title="Informações do modelo">
      <DetailRow label="Nome" value={model?.name} />
      <DetailRow label="Jogo" value={model?.game} />
      <DetailRow label="Edição" value={model?.edition} />
      <DetailRow label="Raridade" value={model?.rarity} />
      <DetailRow label="Ano" value={model?.year} />
      <DetailRow label="Idioma" value={model?.language} />
      <DetailRow label="Numeração" value={model?.numbering} />
    </MobileFilterSheet>
  );
}
